import React, { FC }   from "react";
import { useSelector } from "react-redux";
import { Statistic }   from "semantic-ui-react";
import Reservations    from "../../../domain/reservation/Reservations";
import { ResKaState }  from "../../../index";

const ReservationCounter: FC = () => {
  const reservations: Reservations = useSelector((state: ResKaState) => state.reservations);
  return (
    <>
      <Statistic size="mini" horizontal>
        <Statistic.Label style={ {width: "4rem"} }>予約数</Statistic.Label>
        <Statistic.Value>{ reservations.toList().length }</Statistic.Value>
      </Statistic>
    </>
  );
}

export default ReservationCounter;
